import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const EmptyMessage = () => {
  const { t } = useTranslation()

  return (
    <Styles.Container>
      <Text type="titleS">{t('No hay criterios de disponibilidad todavía.')}</Text>
      <Text type="bodyMRegular">
        {t('Crea tu primer criterio para controlar cuándo están disponibles los métodos de devolución.')}
      </Text>
    </Styles.Container>
  )
}

export default EmptyMessage
